import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, BarChart3, Calendar, Search } from "lucide-react";
import { Link } from "react-router-dom";
import heroImage from "@/assets/landing-hero.jpg";
import Layout from "@/components/Layout";
import PageHeader from "@/components/PageHeader";

const HomePage = () => {
  const mainActions = [
    {
      icon: FileText,
      title: "Créer Analyse",
      description: "Importer et analyser de nouveaux CV avec l'IA",
      link: "/appels-offres/nouveau",
      iconBg: "bg-primary/10",
      iconColor: "text-primary"
    },
    {
      icon: Search,
      title: "Visualiser Analyse",
      description: "Consulter et modifier les analyses existantes",
      link: "/appels-offres",
      iconBg: "bg-secondary",
      iconColor: "text-foreground"
    },
    {
      icon: BarChart3,
      title: "Dashboard",
      description: "Accéder au tableau de bord et statistiques",
      link: "/reporting",
      iconBg: "bg-accent/10",
      iconColor: "text-accent"
    },
    {
      icon: Calendar,
      title: "Planning",
      description: "Visualiser le planning Gantt des projets",
      link: "/planning-ao",
      iconBg: "bg-muted",
      iconColor: "text-foreground"
    }
  ];

  return (
    <Layout>
      <div className="space-y-8">
        <div className="relative mb-6 h-[240px] overflow-hidden rounded-xl border border-border md:h-[320px]">
          <img
            src={heroImage}
            alt="AO Manager - Gestion d'appels d'offres"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/15" />
          <div className="absolute inset-0 flex items-end justify-start p-6 md:p-10">
            <div className="space-y-4">
              <h2 className="text-3xl font-bold text-white drop-shadow-md md:text-4xl">
                Espace de travail AO
              </h2>
              <p className="max-w-xl text-left text-base text-white/90 md:text-lg">
                Lancez vos analyses, suivez vos échéances et centralisez les décisions de sélection.
              </p>
            </div>
          </div>
        </div>

        <PageHeader
          title="Que souhaitez-vous faire ?"
          description="Sélectionnez une action pour commencer."
          className="pb-5"
        />

        <div className="mx-auto max-w-5xl">
          <div className="grid gap-5 md:grid-cols-2">
            {mainActions.map((action, index) => (
              <Link
                key={index}
                to={action.link}
                className="block"
              >
                <Card
                  className="h-full cursor-pointer border-border/70 transition duration-200 hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-lg"
                >
                  <CardHeader className="space-y-4">
                    <div className={`h-16 w-16 rounded-2xl ${action.iconBg} flex items-center justify-center`}>
                      <action.icon className={`h-8 w-8 ${action.iconColor}`} />
                    </div>
                    <CardTitle className="text-2xl">{action.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base">
                      {action.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
